const tab_sections = {
    overview: '概觀',
    authentication: '身份驗證',
    authorization: '授權',
    users: '用戶',
    developer: '開發者',
    tenant: '租戶',
};
export default Object.freeze(tab_sections);
